import type { SubAccount } from '../types';
import { compareDisplayNameOrName } from './sorting';

/**
 * Sorts sub accounts by DisplayName (fallback to Name), then Name for stability.
 * Use when displaying sub account lists for consistent alphabetical ordering.
 */
export function sortSubAccountsByDisplayName<T extends Pick<SubAccount, 'Name'> & { DisplayName?: string | null }>(
  subAccounts: T[]
): T[] {
  return [...subAccounts].toSorted((a, b) => compareDisplayNameOrName(a, b));
}
